import React from "react";
import { useSelector } from "react-redux";
import { DynamicDataTable } from "./DynamicDataTable";
import { MatrixList } from "./MatrixList";
import '../../assets/styles.css';

export default function MatrixViewer() {
    const { matricesData } = useSelector((state) => state.rules);

    return (
        <div className="p-2">
            <strong>Matrix: </strong><span className="span-400"><MatrixList /></span>            
            <pre className="p-2 rounded text-sm text-left overflow-x-auto overflow-y-auto" >
                <DynamicDataTable data={matricesData} />
            </pre>
        </div>
    )
}